export const VULNERABILITIES = {
  DASHBOARD: {
    TITLE: 'Vulnerabilidades de Infraestructura',
    OVERVIEW_TITLE: 'Dashboard de Infraestructura',
  },
  SUMMARY: {
    VULNERABILITIES: 'Vulnerabilidades',
    AFFECTED_HOSTS: 'Hosts Afectados',
    PROVIDERS: 'Proveedores',
    SEVERITY_BREAKDOWN: 'Desglose por Severidad',
    STATUS: 'Estado',
    NO_DATA: 'Sin datos',
  },
  TOP_RISK_HOSTS: {
    TITLE: 'Hosts en Riesgo',
    NO_DATA: 'Sin datos disponibles',
  },
  TRENDS: {
    TITLE: 'Tendencias',
    LAST_SCAN: 'Último escaneo',
    TIME_RANGES: {
      LAST_12_MONTHS: 'Últimos 12 meses',
      LAST_6_MONTHS: 'Últimos 6 meses',
      LAST_3_MONTHS: 'Últimos 3 meses',
    },
    CHART: {
      VULNERABILITIES: 'Vulnerabilidades',
      CRITICAL: 'Crítico',
      HIGH: 'Alto',
      MEDIUM: 'Medio',
      LOW: 'Bajo',
    },
  },
  LIST: {
    SEARCH_PLACEHOLDER: 'Buscar vulnerabilidades...',
    EMPTY_STATE: 'No se encontraron vulnerabilidades que coincidan con tus criterios.',
  },
  FILTERS: {
    PROVIDERS: 'Proveedores',
    ACCOUNTS: 'Cuentas',
    SEVERITY: {
      ALL: 'Todos',
      CRITICAL: 'Crítico',
      HIGH: 'Alto',
      MEDIUM: 'Medio',
      LOW: 'Bajo',
    },
    STATUS: {
      OPEN: 'Abiertas',
      CLOSED: 'Cerradas',
      MUTED: 'Silenciadas',
    },
  },
  MUTE: {
    MUTE_BUTTON: 'Silenciar vulnerabilidad',
    UNMUTE_BUTTON: 'Reactivar vulnerabilidad',
    DIALOG_TITLE: 'Motivo del silenciado',
    SELECTION_SUMMARY: (selected: number, total: number) =>
      `${selected} de ${total} instancias afectadas seleccionadas`,
    JUSTIFICATION_LABEL: 'Justificación',
    JUSTIFICATION_PLACEHOLDER:
      '¿Por qué se silencia esta vulnerabilidad? p. ej. falso positivo en esta imagen, ' +
      'riesgo aceptado hasta que se parchee la instancia',
    CANCEL: 'Cancelar',
    BANNER_TITLE: (muted: number, total: number) => `Silenciada · ${muted} de ${total} instancias afectadas`,
    MUTED_BADGE: 'Silenciada',
    MUTED_BY: (name: string) => `Silenciada por ${name}`,
    BY_SCANNER: 'Silenciada por el escáner de vulnerabilidades',
    NOTHING_SELECTED_TOOLTIP: 'Selecciona al menos una instancia afectada',
    DORMANT_NOTE: 'Este silenciado volverá a aplicarse si la vulnerabilidad aparece en un análisis futuro',
    MUTE_SUCCESS: 'Vulnerabilidad silenciada',
    UNMUTE_SUCCESS: 'Vulnerabilidad reactivada',
    MUTE_PARTIAL: (muted: number, requested: number) =>
      `Silenciadas ${muted} de ${requested} instancias — el resto ya no estaban abiertas`,
    UNMUTE_PARTIAL: (unmuted: number, requested: number) =>
      `Reactivadas ${unmuted} de ${requested} instancias — el resto ya no estaban silenciadas`,
    MUTE_ERROR: 'No se ha podido silenciar la vulnerabilidad',
    UNMUTE_ERROR: 'No se ha podido reactivar la vulnerabilidad',
  },
  ITEM: {
    HOSTS: 'hosts',
    MORE: 'más',
  },
  DRAWER: {
    SUMMARY: {
      TITLE: 'Resumen',
      SEVERITY: 'Severidad',
      CVSS: 'CVSS',
      HOSTS: 'Hosts',
    },
    DESCRIPTION: {
      TITLE: 'Descripción',
    },
    REMEDIATION: {
      TITLE: 'Remediación',
    },
    AFFECTED_HOSTS: {
      TITLE: 'Hosts Afectados',
      FIELDS: {
        IP: 'IP',
        VPC: 'VPC',
        PORT_PROTOCOL: 'Puerto y Protocolo',
        REGION: 'Región',
        STATUS: 'Estado',
      },
      STATUS: {
        OPEN: 'Abierta',
        CLOSED: 'Cerrada',
        MUTED: 'Silenciada',
      },
    },
  },
}
